import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

/**
 * Anonymous game-session storage.
 *
 * IMPORTANT: The value stored under SESSION_KEY is NOT an authentication token
 * or a user credential. It is a server-issued anonymous UUID that identifies an
 * in-progress game run so progress and the camera roll survive page reloads.
 * The backend exposes session data publicly to anyone who holds the id (this is
 * an intentional anonymous-play design — no login, no PII). localStorage is the
 * correct place for a non-secret, per-browser identifier like this.
 */
const SESSION_KEY = "eitd_session_id";

export function getStoredSessionId() {
    return localStorage.getItem(SESSION_KEY);
}

export function storeSessionId(id) {
    localStorage.setItem(SESSION_KEY, id);
}

export function clearStoredSessionId() {
    localStorage.removeItem(SESSION_KEY);
}

export async function createSession(nickname) {
    const params = nickname ? { nickname } : {};
    const { data } = await axios.post(`${API}/sessions`, null, { params });
    storeSessionId(data.id);
    return data;
}

export async function getSession(id) {
    const { data } = await axios.get(`${API}/sessions/${id}`);
    return data;
}

export async function updateSession(id, patch) {
    const { data } = await axios.patch(`${API}/sessions/${id}`, patch);
    return data;
}

export async function savePhoto(sessionId, payload) {
    const { data } = await axios.post(`${API}/sessions/${sessionId}/photos`, payload);
    return data;
}

export async function listPhotos(sessionId) {
    const { data } = await axios.get(`${API}/sessions/${sessionId}/photos`);
    return data;
}

export async function generatePhotoImage(sessionId, photoId) {
    const { data } = await axios.post(`${API}/sessions/${sessionId}/photos/${photoId}/generate-image`);
    return data; // { data_url, cached }
}

export async function fetchPhotoImage(sessionId, photoId) {
    const { data } = await axios.get(`${API}/sessions/${sessionId}/photos/${photoId}/image`);
    return data; // { data_url }
}

export async function getLeaderboard() {
    const { data } = await axios.get(`${API}/leaderboard`);
    return data;
}
